import { RecipeDetailQueryDocument, RecipeRelateResponse } from '@modules/libs/graphql/generated/graphql';
import { gqlQuery } from '@modules/libs/graphql/gql-config';
import { IRecipeDetailRepository } from '@modules/recipes/application/ports/recipeDetail.repository.port';
import { right } from '@shared/utils/either.utils';
import { RecipeEntityMapper } from '../../outbound/ports/recipeDetail.mapper';
export class RecipeDetailRepositoryImpl implements IRecipeDetailRepository {
  async getDetail(slug: string): IRecipeDetailRepository.getDetailOutput {
    try {
      const {
        data,
        errors
      } = await gqlQuery({
        query: RecipeDetailQueryDocument,
        variables: {
          data: {
            slug
          }
        }
      });
      if (errors) throw errors[0].message ?? 'Unknow Error';
      const output: RecipeRelateResponse = data.getRecipe;
      return right(RecipeEntityMapper.toDomain(output));
    } catch (error: any) {
      console.error('error RecipeRepositoryImpl', error);
      throw {
        data: error,
        message: error.message,
        statusCode: error.graphQLErrors[0].extensions.code
      };
    }
  }
}